<template>
  <v-navigation-drawer
    v-model="dialog"
    :right="true"
    fixed
    temporary
    width="500"
    height="100vh"
  >
    <v-card class="grey lighten-4 elevation-0">
      <v-card-title>
        <span class="headline">Comments</span>
      </v-card-title>
      <v-container
        id="comments-container"
        class="comments-scrolled-content-container"
      >
        <v-timeline dense v-if="comments && comments.length">
          <v-timeline-item
            v-for="comment in comments"
            :key="comment.id"
            color="white"
          >
            <template v-slot:icon>
              <v-icon
                color="primary"
                v-if="comment.user && comment.user.id === 1"
              >
                mdi-robot
              </v-icon>
              <v-icon
                color="yellow"
                v-else-if="comment.user && comment.user.id === 2"
              >
                mdi-face
              </v-icon>

              <v-avatar v-else-if="comment.user && comment.user.picture">
                <img
                  :src="
                    comment.user && comment.user.picture
                      ? comment.user.picture
                      : ''
                  "
                />
              </v-avatar>
            </template>

            <span slot="opposite">{{ comment.user.name }}</span>
            <v-card class="elevation-2">
              <v-card-title>
                <v-tooltip v-if="comment.status" bottom max-width="200">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      class="mr-2"
                      :color="getStatusByName(comment.status.name).color"
                    >
                      {{ getStatusByName(comment.status.name).icon }}
                    </v-icon>
                  </template>
                  <span>{{ comment.status.title }}.</span>
                </v-tooltip>

                {{ comment.user.name }}
              </v-card-title>
              <v-card-text>
                {{ comment.message }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <div class="text-center" v-else>No comments yet...</div>
        <div id="end"></div>
      </v-container>

      <v-card-actions class="white">
        <v-container @keyup.enter="addComment">
          <v-divider></v-divider>
          <div
            v-if="!activeCustomerView"
            class="text-left filters-container pa-2"
          >
            <v-slide-group show-arrows v-model="newCommentStatus">
              <v-slide-item
                v-for="(filter, index) in rowStatusesComputed"
                :value="filter"
                :key="index"
                v-slot:default="{ active, toggle }"
              >
                <v-chip
                  filter
                  outlined
                  @click="toggle"
                  :input-value="active"
                  :value="filter.id"
                  class="mr-2"
                  :color="filter.color"
                >
                  <v-icon left>{{ filter.icon }}</v-icon>
                  <span class="grey--text text--darken-1">
                    {{ filter.title }}
                  </span>
                </v-chip>
              </v-slide-item>
            </v-slide-group>
          </div>
          <v-divider></v-divider>
          <v-textarea
            v-model="newCommentMessage"
            auto-grow
            full-width
            placeholder="Start enter your comment..."
            rows="2"
          ></v-textarea>
        </v-container>
      </v-card-actions>
    </v-card>
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-navigation-drawer>
</template>

<script>
import { processingResultsApiV2 } from '@/api/v2';
import { DEFAULTS } from '../../constants';
import { processingResultsApiV1 } from '@/api/v1';

export default {
  name: 'FileCommentDialog',
  props: {
    role: {
      type: String,
      default: ''
    },
    rowStatuses: {
      type: Array,
      default: () => []
    },
    activeCustomerView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rowStatusesComputed() {
      if (!this.rowStatuses || !this.rowStatuses.length) return [];
      const namedStatuses = this.rowStatuses.map((el) => el.name);
      const statusesToMap =
        this.role === 'customer'
          ? this.showStatuses.customer
          : this.showStatuses.default;

      return statusesToMap.map((name) => {
        const indexOfStatus = namedStatuses.indexOf(name);
        return {
          ...this.rowStatuses[indexOfStatus],
          icon: this.getStatusByName(name).icon,
          color: this.getStatusByName(name).color
        };
      });
    }
  },
  data: () => ({
    selectedRow: undefined,
    loading: false,
    newCommentMessage: undefined,
    newCommentStatus: undefined,
    dialog: false,
    comments: [],
    form: {
      file: '',
      type: '',
      categorymap: '',
      filters: '',
      defaultlab: '',
      preset: ''
    },
    showStatuses: DEFAULTS.SHOW_STATUSES
  }),
  methods: {
    open(selectedRow) {
      this.selectedRow = selectedRow;
      this.getComments();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    getStatusByName(statusName) {
      const status = DEFAULTS.ROWS_STATUSES[statusName];
      if (status) return status;
      else {
        console.log('statusName: ', statusName);
        return DEFAULTS.ROWS_STATUSES.not_reviewed;
      }
    },
    getComments() {
      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .fetchResultRowComments(
          this.$route.params.result_id,
          this.selectedRow.id
        )
        .then((response) => {
          this.loading = false;
          this.comments = response.items;
          setTimeout(() => {
            this.scrollToBottom();
          }, 100);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    addComment() {
      console.log('addComment ', this.newCommentMessage);
      console.log('newCommentStatus ', this.newCommentStatus);
      if (!this.newCommentMessage && !this.newCommentStatus) return;

      return (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      )
        .addResultRowComment({
          resultId: this.$route.params.result_id,
          rowId: this.selectedRow.id,
          message:
            this.newCommentStatus && this.newCommentStatus.id
              ? this.newCommentMessage +
                `\nStatus was changed to "${this.newCommentStatus.title}"`
              : this.newCommentMessage,
          statusId:
            this.newCommentStatus && this.newCommentStatus.id
              ? this.newCommentStatus.id
              : undefined
        })
        .then(() => {
          // if (this.newCommentStatus && this.newCommentStatus.id)
          this.$emit('refresh');
          this.newCommentStatus = undefined;
          this.newCommentMessage = undefined;
          this.getComments();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    scrollToBottom() {
      console.log('scrollToBottom');
      const container = document.getElementById('comments-container');
      container.scrollTop = Math.floor(container.scrollHeight);
    }
  }
};
</script>

<style lang="scss">
.comments-scrolled-content-container {
  min-height: 50vh;
  overflow-y: scroll;
  .v-timeline {
    max-height: 60vh !important;
  }
}
</style>
